import { PasswordStrengthField } from '@/components/PasswordStrength';
import { passwordPattern, passwordRuleMessage } from '@/utils/passwordPolicy';
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-no-target-blank */
import { LockOutlined } from '@ant-design/icons';
import { Button, Form, Input, message } from '@sinohealth/butterfly-ui-components';
import React, { useState } from 'react';
import { userResetPassword } from '@/common/components/BasicLogin/http';
import SubmitButton from '@/common/components/BasicLogin/components/SubmitButton';
import styles from '@/common/components/BasicLogin/components/ResetPassword/index.less';

const { useForm } = Form;

type AccountPasswordLoginProps = {
  /** 白色背景 */
  white?: boolean;
  token?: string;
  backLogin?: () => void; // 忘记密码地址
  onNext?: () => void;
};

/** 设置新密码 */
const ResetPassword: React.FC<AccountPasswordLoginProps> = (props) => {
  const { white, onNext, token, backLogin } = props;

  const [form] = useForm();
  const [canLogin, setCanLogin] = useState(false);

  const onFinish = (values: any) => {
    setCanLogin(true);
    userResetPassword({ password: values.password }, { token }).then(() => {
      onNext && onNext();
    });
  };

  const validPassword = (rule: any, value: any) => {
    const password = form.getFieldValue('password');
    if (!value) {
      return Promise.reject('确认密码不能为空');
    }
    if (password !== value) {
      return Promise.reject('两次密码不一致');
    }
    return Promise.resolve();
  };

  const getErrorMessage = () => {
    const errors = form.getFieldsError();
    let errorMessage: string[] = [];
    errors.forEach((item) => {
      errorMessage = errorMessage.concat(item.errors);
    });
    const errorMsg = errorMessage.reverse().pop();
    errorMsg && message.error(errorMsg);
  };

  return (
    <Form
      form={form}
      className="container"
      size="large"
      onFinish={onFinish}
      onFinishFailed={getErrorMessage}
    >
      <Form.Item
        name="password"
        noStyle
        rules={[
          { required: true, message: '登录密码不能为空' },
          { pattern: passwordPattern, message: passwordRuleMessage },
        ]}
      >
        <Input.Password
          className={`${styles['custom-input']} ${white ? styles['white-background'] : ''}`}
          prefix={<LockOutlined />}
          placeholder="10-20位，须含字母、数字、符号"
          autoComplete="off"
          onBlur={getErrorMessage}
        />
      </Form.Item>

      <PasswordStrengthField name="password" />
      <Form.Item
        name="pwd"
        dependencies={['password']}
        noStyle
        rules={[{ required: true, validator: validPassword }]}
      >
        <Input.Password
          className={`${styles['custom-input']} ${white ? styles['white-background'] : ''}`}
          prefix={<LockOutlined />}
          placeholder="再次确认新密码"
          autoComplete="off"
          onBlur={getErrorMessage}
        />
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }} style={{ marginTop: 168 }}>
        {/* <Button
          className={`${styles['custom-btn']} ${!canLogin ? styles.disabled : ''}`}
          type="primary"
          htmlType="submit"
          size="large"
          block
        >
          确定
        </Button> */}
        <SubmitButton
          form={form}
          label="确定"
          buttonProps={{ type: 'primary', style: { marginBottom: 16 }, size: 'large', block: true }}
        />
        <Button className={`${styles['back-btn']}`} size="large" block onClick={backLogin}>
          返回登录
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ResetPassword;
